import { useState } from "react";
import { useTranslation } from "react-i18next";
import { alpha, Stack, Typography, useTheme } from "@mui/material"
import { ModalHelp } from "../Modals/ModalHelp";
import { InvestigationButton } from "./InvestigationButton";

export const InvestigationSectionHeader = ({
  text = '',
  buttonText = "",
  buttonIcon,
  onClick = ()=>{},
  type = "",
  hideButton = false,
  extraButtons = []
}) => {

  const theme = useTheme();
  const [showModalHelp, setShowModalHelp] = useState(false);

  return (
    <>
      <ModalHelp 
        show={showModalHelp}
        onHide={() => setShowModalHelp(false)}
        type={type}
      />
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        padding={2} 
        boxShadow={`0px 4px 2px 0px ${alpha(theme.palette.oxfordBlue.main, .25)}`}
        sx={{ backgroundColor: theme.palette.blueGray50.main }}
      >
        <Typography variant="h5">
          {text}
        </Typography>
        <Stack direction="row" spacing={2}>
          {
            Array.isArray(extraButtons) && extraButtons.length > 0 && (
              extraButtons.map((button, index) => (
                <>
                  {button}
                  <div style={{
                    width: 1,
                    height: "100%",
                    backgroundColor: theme.palette.blueGray200.main,
                    color: 'transparent' }}
                  >
                    .
                  </div>
                </>
              ))
            )
          }
          {
            !hideButton &&
            <InvestigationButton 
              label={buttonText} 
              icon={buttonIcon} 
              size="thin"
              width={200}
              onClick={onClick}
            />
          }
          
          {/* <div style={{
            width: 1,
            height: "100%",
            backgroundColor: theme.palette.blueGray200.main,
            color: 'transparent' }}
          >
            .
          </div>
          <InvestigationButton 
            icon={"outline_question_circle"} 
            size="thin"
            onClick={() => setShowModalHelp(true)}
          /> */}
        </Stack>

      </Stack>
    </>
  )
}
